<template>
    <b-menu
        class="list-osa scrollbar scrollbar-primary"
        style="height: 100%; max-height: 500px; overflow: auto; min-height: -webkit-fill-available; overflow-x: hidden"
    >
        <b-menu-list>
            <template slot="label">
                Folders
                <div @click="showAddFolder" style="float: right">
                    <b-icon icon="plus-circle" type="is-primary"></b-icon>
                </div>
            </template>
            <b-menu-item @click="select({ id: null })" icon="folder" :active="isAllActive">
                <template #label>
                    <p class="folder-name pointer">All files</p>
                </template>
            </b-menu-item>
            <b-menu-item :key="f.id" @click="select(f)" icon="folder" v-for="f in list" :active="f.active">
                <template #label>
                    <p class="folder-name pointer" :title="f.name">{{ f.name }}</p>
                </template>
            </b-menu-item>
        </b-menu-list>
    </b-menu>
</template>

<script>
export default {
    name: "FolderMenu",
    props: {
        list: {
            type: Array,
            default: () => [],
        },
        // items: Array,
        // folderType: String,
    },
    data() {
        return {
            text: "",
            // selectedFolder: null,
            value: null,
            isLoading: true,
            isAllActive: true,
        };
    },
    methods: {
        select(option) {
            this.$emit("input", option.id);
        },
        showAddFolder() {
            this.$buefy.dialog.prompt({
                message: "Folder Name",
                inputAttrs: {
                    placeholder: "New Folder Name",
                    maxlength: 45,
                },
                confirmText: "Add",
                onConfirm: async (value) => {
                    // Adding new folder
                    try {
                        let tmp = await this.$http.post("/folders", {
                            name: value,
                        });
                        this.$store.commit("ADD_FOLDER", tmp.data);
                        this.select(tmp.data);
                        this.text = tmp.data.name;
                        this.isAllActive = false;
                    } catch (e) {
                        this.notify("Failed to add the folder", "is-danger");
                    }
                },
            });
        },
    },
};
</script>

<style>
.folder-name {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 0.83rem;
}

.scrollbar[data-v-48bc54b6] {
    float: left;
    background: #fff;
    overflow-y: scroll;
}

.scrollbar-primary[data-v-48bc54b6]::-webkit-scrollbar {
    width: 10px;
    background-color: #f5f5f5;
}

.scrollbar-primary[data-v-48bc54b6]::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #515151;
}

.scrollbar-primary[data-v-48bc54b6] {
    scrollbar-color: #4285f4 #f5f5f5;
}
</style>